import React, {Component} from 'react';

class Logo extends Component{

    render(){
        return (
            <div className="header-branding m-large-logo">
                <span>
                    <img
                        src={require(`${this.props.src}`)}
                        alt={this.props.alt}
                        width={this.props.width}
                        height={this.props.height}
                    />
                </span>
            </div>
        )
    }
}

export default Logo


// WEBPACK FOOTER //
// ./src/components/header/Logo.js